import React, { Fragment } from 'react';

const DrivingPLUS = () => (
  <Fragment>
    <p>
      If you're interested in driving Autzu PLUS vehicles, you need to take
      a short course and quiz. The training course is normally valued at
      $250 and we provide it to you for absolutely free! You can access it{' '}
      <a className="faq__panel--link" href="http://www.autzu.com/course">
        here
      </a>. Once you have passed the quiz, you may book your first PLUS
      booking and you will get a 15 minute in-person demonstration before
      you start driving.
    </p>
  </Fragment>
);

export default DrivingPLUS;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/DrivingPLUS.js